export default "__VITE_ASSET__Czio6cVr__"